export type Maybe<T> = T | null
export const ADDRESS_REGEX = /^0x[a-fA-F0-9]{40}$/
export const POSITIVE_NUMBER = /^\d+(\.\d{1,4})?$/
